export const getLocalStorageItem = (itemName: string) =>
  localStorage.getItem(itemName);

export const setLocalStorageItem = (itemName: string, itemValue: string) =>
  localStorage.setItem(itemName, itemValue);
